import { render, staticRenderFns } from "./McQueryTable.vue?vue&type=template&id=66723516&scoped=true&"
import script from "./McQueryTable.vue?vue&type=script&lang=js&"
export * from "./McQueryTable.vue?vue&type=script&lang=js&"
import style0 from "./McQueryTable.vue?vue&type=style&index=0&id=66723516&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66723516",
  null
  
)

export default component.exports